import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SparkleEffect } from '../components/SparkleEffect';
import { GlitterHeart } from '../components/GlitterHeart';
import { SplitFlapQuote } from '../components/SplitFlapQuote';
import { ArrowRightIcon, HeartIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
export function FreeResourcesPage() {
  return <div className="min-h-screen bg-white pt-24 pb-24" data-id="element-2253" data-mp="1q0mv2i227ym4">
      {/* Hero */}
      <section className="relative py-20 text-center overflow-hidden bg-gradient-to-b from-blush-50 to-white" data-id="element-2254" data-mp="1l2lattswdt92">
        <SparkleEffect count={80} data-id="element-2255" data-mp="1z2md9dot98qn" />
        <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-2256" data-mp="1z3nzmeba1hno">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="font-heading text-5xl md:text-6xl font-bold text-plum-700 mb-6" data-id="element-2257" data-mp="1uzzqvsawsg0u">
            Trippin' Through <span className="text-cta-500" data-id="element-2258" data-mp="1rg0mqhni3fwj">Guidance</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-plum-500 font-medium" data-id="element-2259" data-mp="1we28598efrb6">
            Tools, support, and a gentle reminder that you don't have to figure
            it all out alone.
          </motion.p>
        </div>
      </section>

      {/* SPARKLY QUOTE MARQUEE */}
      <SplitFlapQuote data-id="element-2260" data-mp="1hp5yj7qp268g" />

      {/* REDESIGNED CRISIS SECTION */}
      <section className="py-16 bg-gradient-to-br from-lavender-50 via-blush-50 to-pink-50 relative overflow-hidden" data-id="element-2261" data-mp="1mg4ichaw5mgg">
        <SparkleEffect count={40} data-id="element-2262" data-mp="p1a6whfzf4ij" />

        {/* Decorative blurred circles for soft glow */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-2263" data-mp="tzk04mi5bv1i" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-pink-100/40 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3 pointer-events-none" data-id="element-2264" data-mp="1x96d31da9hdj" />

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2265" data-mp="263kp8v2iobsf">
          <div className="text-center mb-12" data-id="element-2266" data-mp="221fyc43gdt9h">
            <GlitterHeart size={40} variant="light" className="mx-auto mb-4" data-id="element-2267" data-mp="222ir6hkc65s1" />
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-plum-700 mb-3" data-id="element-2268" data-mp="1ebdbc2eebdhq">
              If You're Not Okay Right Now
            </h2>
            <p className="text-plum-600 text-lg font-medium max-w-2xl mx-auto" data-id="element-2269" data-mp="19ev856yprn7i">
              You're not alone. You don't have to go through this by yourself.
            </p>
          </div>

          {/* IMMEDIATE CRISIS HELP */}
          <div className="mb-12" data-id="element-2270" data-mp="2yrgkrwgcnxnm">
            <h3 className="font-heading text-xl font-bold text-plum-700 mb-6 flex items-center gap-2" data-id="element-2271" data-mp="2yqf7dlbv2z2q">
              <span className="text-2xl" data-id="element-2272" data-mp="2tru75lwm0fea">🚨</span> Immediate Crisis Help
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2273" data-mp="328l04puhwxpi">
              {/* Card 1: Lifeline */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-2274" data-mp="36c0xjoee3239">
                <div className="flex items-center gap-3 mb-4" data-id="element-2275" data-mp="2sd18wgqvmn73">
                  <div className="w-10 h-10 rounded-full bg-sky-50 flex items-center justify-center shrink-0" data-id="element-2276" data-mp="2x9rnezn19aqe">
                    <PhoneIcon className="w-5 h-5 text-sky-500" data-id="element-2277" data-mp="3l16v77xkwk91" />
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-2278" data-mp="3pzi51inviur9">
                    Suicide & Crisis Lifeline
                  </h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-2279" data-mp="3b8hv197hast0">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-2280" data-mp="3g8dq2iy779wf">Call or text</p>
                  <p className="text-4xl font-black text-plum-800 mb-3 tracking-tight" data-id="element-2281" data-mp="7t3pjf9yicqr">
                    988
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5 mb-1" data-id="element-2282" data-mp="clwvg6h5vr4f">
                    <span className="text-cta-400" data-id="element-2283" data-mp="2k5glhqoe89wk">Chat:</span> 988lifeline.org
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-2284" data-mp="2g0qq02xncxc6">
                    <span data-id="element-2285" data-mp="2b40dfpl1wjvi">🕒</span> Available 24/7, free & confidential
                  </p>
                </div>
                <a href="https://988lifeline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-sky-50 text-sky-600 hover:bg-sky-100 font-bold transition-colors mt-auto" data-id="element-2286" data-mp="265yst07z8chx">
                  Get Help Now <ArrowRightIcon className="w-4 h-4" data-id="element-2287" data-mp="2p3i5cdtn8d93" />
                </a>
              </div>

              {/* Card 2: Text Line */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-2288" data-mp="3mjypm2bizm0y">
                <div className="flex items-center gap-3 mb-4" data-id="element-2289" data-mp="3hqcmp1v5ywic">
                  <div className="w-10 h-10 rounded-full bg-cta-50 flex items-center justify-center shrink-0" data-id="element-2290" data-mp="3p3ve3gcq0nq2">
                    <MessageCircleIcon className="w-5 h-5 text-cta-500" data-id="element-2291" data-mp="3u2ohuh27h0d1" />
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-2292" data-mp="2usqx8ltt4u6">
                    Crisis Text Line
                  </h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-2293" data-mp="bwa4aj7umsf6">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-2294" data-mp="bvii1z05671k">
                    Text <strong className="text-plum-800" data-id="element-2295" data-mp="guv2ye7gd41i">HOME</strong> to
                  </p>
                  <p className="text-4xl font-black text-plum-800 mb-3 tracking-tight" data-id="element-2296" data-mp="lmd87egidqsa">
                    741741
                  </p>
                  <p className="text-plum-500 text-sm font-medium mb-1" data-id="element-2297" data-mp="qjv7ed4q4rn3">
                    Connects you with a trained crisis counselor
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-2298" data-mp="zll6840xqsuw">
                    <span data-id="element-2299" data-mp="2wm8xv01k3cqc">🕒</span> Available 24/7
                  </p>
                </div>
                <a href="https://www.crisistextline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-cta-50 text-cta-600 hover:bg-cta-100 font-bold transition-colors mt-auto" data-id="element-2300" data-mp="2rne7nd19elw7">
                  Talk to Someone <ArrowRightIcon className="w-4 h-4" data-id="element-2301" data-mp="3fb5h88vf0kts" />
                </a>
              </div>

              {/* Card 3: Emergency */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-2302" data-mp="3odog6hw2ydar">
                <div className="flex items-center gap-3 mb-4" data-id="element-2303" data-mp="3kbjr7wgku4ug">
                  <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center shrink-0" data-id="element-2304" data-mp="3k9yv42em6duh">
                    <span className="text-xl" data-id="element-2305" data-mp="1u1gqbiym8mlu">🚓</span>
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-2306" data-mp="1pzv7lgzehe3q">Emergency</h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-2307" data-mp="1fuwxtxmqduv6">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-2308" data-mp="1jvyqfvm578o6">Call</p>
                  <p className="text-4xl font-black text-red-500 mb-3 tracking-tight" data-id="element-2309" data-mp="164bujww4425x">
                    911
                  </p>
                  <p className="text-plum-500 text-sm font-medium" data-id="element-2310" data-mp="1b2loy5a0iyqh">
                    If someone is in immediate danger
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* SPECIALIZED SUPPORT */}
          <div className="mb-8" data-id="element-2311" data-mp="112uuu4pd6lqx">
            <h3 className="font-heading text-xl font-bold text-plum-700 mb-6 flex items-center gap-2" data-id="element-2312" data-mp="n5zm6dd0ywbe">
              <span className="text-2xl" data-id="element-2313" data-mp="s3rayyidi2bd">💖</span> Specialized Support
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2314" data-mp="2hixr0hfyh0rc">
              {/* Trevor Project */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-2315" data-mp="2mhirmhz4dmgb">
                <div className="flex items-center gap-3 mb-3" data-id="element-2316" data-mp="3v3973v1orymt">
                  <span className="text-2xl" data-id="element-2317" data-mp="3q3wjh82zqnj6">🌈</span>
                  <h4 className="font-bold text-plum-800" data-id="element-2318" data-mp="3q57kx18yrj74">LGBTQ+ Support</h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-2319" data-mp="3lbv9xtx7jawu">
                  The Trevor Project
                </p>
                <div className="space-y-2 mb-4" data-id="element-2320" data-mp="3cci0v2czwocn">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-2321" data-mp="3cdaxvbm5jzhl">
                    1-866-488-7386
                  </p>
                  <p className="text-plum-600 text-sm font-medium" data-id="element-2322" data-mp="37fhu0p8bnhkh">
                    Text <strong className="text-plum-800" data-id="element-2323" data-mp="32f3kf2r2nzkc">START</strong> to{' '}
                    <strong className="text-plum-800" data-id="element-2324" data-mp="2ydibttlkm7fy">678678</strong>
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-2325" data-mp="10ngznixrx0wb">
                    <span data-id="element-2326" data-mp="wku4p95t2zuw">🕒</span> 24/7 support for LGBTQ+ youth
                  </p>
                </div>
                <a href="https://www.thetrevorproject.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-2327" data-mp="2eji9zlp30gd2">
                  Get Support <ArrowRightIcon className="w-3 h-3" data-id="element-2328" data-mp="2s9c2qf3pjks2" />
                </a>
              </div>

              {/* SAMHSA */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-2329" data-mp="1vlz0yi2mixqn">
                <div className="flex items-center gap-3 mb-3" data-id="element-2330" data-mp="20jr304wzg08k">
                  <span className="text-2xl" data-id="element-2331" data-mp="24kaxf0q68pr0">🧠</span>
                  <h4 className="font-bold text-plum-800" data-id="element-2332" data-mp="24mx6x5wmhfbv">
                    Mental Health & Substance Use
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-2333" data-mp="3g0r70df1oc5y">
                  SAMHSA National Helpline
                </p>
                <div className="space-y-2" data-id="element-2334" data-mp="3l0vskhut7x31">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-2335" data-mp="gjvfb3gh1eqj">
                    1-800-662-4357
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-2336" data-mp="lif3laijf2m2">
                    <span data-id="element-2337" data-mp="qb87jw66m6x3">🕒</span> 24/7, free, confidential
                  </p>
                </div>
              </div>

              {/* Postpartum */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-2338" data-mp="3troqav83sqws">
                <div className="flex items-center gap-3 mb-3" data-id="element-2339" data-mp="2kvq9up1qxtu">
                  <span className="text-2xl" data-id="element-2340" data-mp="2ldubdhyagcb">👩‍👧</span>
                  <h4 className="font-bold text-plum-800" data-id="element-2341" data-mp="7jyvpg8xv62c">
                    Postpartum Support
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-2342" data-mp="bn50skkber78">
                  For Moms (EN/ES)
                </p>
                <div className="space-y-2 mb-4" data-id="element-2343" data-mp="1n0frx0v2e9zf">
                  <p className="text-plum-600 text-sm font-medium" data-id="element-2344" data-mp="1mz5v0ezy77ud">
                    Call or text:
                  </p>
                  <p className="text-plum-700 font-bold text-lg" data-id="element-2345" data-mp="33heiqg6ax0p8">
                    1-800-944-4773
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-2346" data-mp="2yq67delev59f">
                    <span data-id="element-2347" data-mp="2ts4qn0bgji14">🕒</span> Not 24/7, but very responsive
                  </p>
                </div>
                <a href="https://www.postpartum.net/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-2348" data-mp="2oss5ql45cl16">
                  Visit Website <ArrowRightIcon className="w-3 h-3" data-id="element-2349" data-mp="2atsi9gsdec6l" />
                </a>
              </div>

              {/* Domestic Violence */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-2350" data-mp="dzp90p4dxc6t">
                <div className="flex items-center gap-3 mb-3" data-id="element-2351" data-mp="925leylsrn27">
                  <span className="text-2xl" data-id="element-2352" data-mp="s5qvwn7pwdcw">💔</span>
                  <h4 className="font-bold text-plum-800" data-id="element-2353" data-mp="s464h6gp9aj9">Domestic Violence</h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-2354" data-mp="wyk4xna7y7us">
                  National Hotline
                </p>
                <div className="space-y-2 mb-4" data-id="element-2355" data-mp="o5gs9h7edz17">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-2356" data-mp="o21b88u5yfx5">
                    1-800-799-7233
                  </p>
                  <p className="text-plum-600 text-sm font-medium" data-id="element-2357" data-mp="1fvbm9r67acw7">
                    Text <strong className="text-plum-800" data-id="element-2358" data-mp="1ft8tizdny5ns">START</strong> to{' '}
                    <strong className="text-plum-800" data-id="element-2359" data-mp="11vk9ftrf72js">88788</strong>
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-2360" data-mp="16tc06kgbwime">
                    <span data-id="element-2361" data-mp="3ml9pga3v0ue2">🕒</span> 24/7
                  </p>
                </div>
                <a href="https://www.thehotline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-2362" data-mp="3rm5q8esx00f9">
                  Get Support <ArrowRightIcon className="w-3 h-3" data-id="element-2363" data-mp="3t102rizb30ij" />
                </a>
              </div>

              {/* Child Abuse */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-2364" data-mp="3o13xzhisb51x">
                <div className="flex items-center gap-3 mb-3" data-id="element-2365" data-mp="30dvr4v5pjnxs">
                  <span className="text-2xl" data-id="element-2366" data-mp="2wcttujvcplyg">👶</span>
                  <h4 className="font-bold text-plum-800" data-id="element-2367" data-mp="2wa7lwj4jt4fp">
                    Child Abuse Hotline
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-2368" data-mp="35cgx7b7n51u5">
                  Childhelp
                </p>
                <div className="space-y-2" data-id="element-2369" data-mp="2hl1n2w9mhg8c">
                  <p className="text-plum-600 text-sm font-medium" data-id="element-2370" data-mp="2col1a8pwbdyf">
                    Call or text:
                  </p>
                  <p className="text-plum-700 font-bold text-lg" data-id="element-2371" data-mp="2qc37k2a4assv">
                    1-800-422-4453
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-2372" data-mp="2va4pukzpyo3a">
                    <span data-id="element-2373" data-mp="307n1ij54fhez">🕒</span> 24/7
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p className="text-center text-plum-500 font-medium italic mt-12" data-id="element-2374" data-mp="3919uk1hy26kh">
            Take a breath. You're going to be okay. 💗
          </p>
        </div>
      </section>

      {/* SECOND MARQUEE - extra positivity */}
      <SplitFlapQuote data-id="element-2375" data-mp="3iz63qnrbmrfy" />

      {/* FREE RESOURCES SECTION */}
      <section className="py-16 bg-white relative overflow-hidden" data-id="element-2376" data-mp="3ixlar2knngk7">
        <SparkleEffect count={60} data-id="element-2377" data-mp="3ny0m5oldmdzj" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2378" data-mp="1olelx0yu919f">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2379" data-mp="1onhmgexmacse">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-plum-700 mb-6" data-id="element-2380" data-mp="1tlj734aoyk5z">
              Free Resources & Reset
            </h2>
            <p className="text-lg text-plum-600 font-medium leading-relaxed" data-id="element-2381" data-mp="ar7y2gyg9lyv">
              I've been through some really hard things in life—and I know what
              it feels like to feel stuck, overwhelmed, or alone. If that's
              where you are right now, please know this:{' '}
              <strong className="text-plum-800" data-id="element-2382" data-mp="3t1jhhyqdioyo">
                you matter, and you don't have to figure it all out by yourself.
              </strong>
            </p>
          </div>

          {/* Free Coaching Call - thin wide card above the grid */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-10" data-id="element-2383" data-mp="kmi0h5srfvd6">
            <a href="https://calendly.com/trippinwithmandy/free-consultation-call" target="_blank" rel="noopener noreferrer" className="flex flex-col sm:flex-row items-center justify-between gap-4 bg-gradient-to-r from-cta-50 to-pink-50 rounded-2xl px-8 py-5 border-2 border-cta-200 shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all" data-id="element-2384" data-mp="30dxfuw0phueg">
              <div className="flex items-center gap-4" data-id="element-2385" data-mp="2xsfxlul0tdsj">
                <span className="text-3xl" data-id="element-2386" data-mp="2j4uyscv6i0qf">💗</span>
                <div data-id="element-2387" data-mp="2j39zk9xx5tm8">
                  <h3 className="font-heading text-lg font-bold text-plum-800" data-id="element-2388" data-mp="2nw35v291da0f">
                    Need Someone to Talk To?
                  </h3>
                  <p className="text-plum-500 font-medium text-sm" data-id="element-2389" data-mp="2a5zn4l9d7yfq">
                    Book a free coaching call — no strings, no judgment, just
                    support.
                  </p>
                </div>
              </div>
              <span className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-cta-500 text-white font-bold text-sm hover:bg-cta-600 transition-colors shadow-lg shadow-cta-500/20 shrink-0" data-id="element-2390" data-mp="208v0kkbly0ye">
                Book a Free Call
                <ArrowRightIcon className="w-4 h-4" data-id="element-2391" data-mp="1gl8pioquprzh" />
              </span>
            </a>
          </motion.div>

          {/* GRID ROW 1 */}
          <div id="free-lists" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8 scroll-mt-32" data-id="element-2392" data-mp="1vjarwvm5c7f5">
            {/* Interactive Cleaning Schedule Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-cta-50 to-white rounded-3xl p-8 border-2 border-cta-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-2393" data-mp="24gur7z0g7tn4">
              <div className="absolute top-4 right-4 bg-cta-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-2394" data-mp="2j8d77wtb5o6h">
                NEW ✨
              </div>
              <div className="text-3xl mb-4" data-id="element-2395" data-mp="3ul3a8bpay2kk">✨</div>
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-4" data-id="element-2396" data-mp="3ujrxvnhsjmhu">
                Free Interactive Cleaning Schedule
              </h3>
              <p className="text-plum-600 font-medium mb-8 flex-grow" data-id="element-2397" data-mp="7hexi6hr84lo">
                The Ultimate Cleaning Schedule — what to clean & when. Check
                things off, track your progress, use it every week for free!
              </p>
              <Link to="/free-resources/cleaning-schedule" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-cta-500 text-white font-bold text-sm hover:bg-cta-600 transition-colors shadow-lg shadow-cta-500/20 w-full" data-id="element-2398" data-mp="3bvd6v07h48h1">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-2399" data-mp="2s74eoq5xk2hj" />
              </Link>
            </motion.div>

            {/* Interactive Self-Care Schedule Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-gradient-to-br from-pink-50 to-white rounded-3xl p-8 border-2 border-pink-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-2400" data-mp="2kmbq79ni7ysa">
              <div className="absolute top-4 right-4 bg-pink-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-2401" data-mp="1wvxv1a9mhjth">
                NEW 🧖‍♀️
              </div>
              <div className="text-3xl mb-4" data-id="element-2402" data-mp="1nv9eo8wrb7df">🧖‍♀️</div>
              <h3 className="font-heading text-2xl font-bold text-pink-800 mb-4" data-id="element-2403" data-mp="1iyj2hwo2ovxa">
                Free Interactive Self-Care Checklist
              </h3>
              <p className="text-pink-600 font-medium mb-8 flex-grow" data-id="element-2404" data-mp="1e1itbcvxfd1y">
                Daily hygiene and wellness ritual. Take care of your body and
                mind with this simple, trackable daily routine!
              </p>
              <Link to="/free-resources/self-care/daily" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-pink-500 text-white font-bold text-sm hover:bg-pink-600 transition-colors shadow-lg shadow-pink-500/20 w-full" data-id="element-2405" data-mp="12s48mz323lbi">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-2406" data-mp="p0h1g47kssdy" />
              </Link>
            </motion.div>

            {/* Free Pre-Trip Home Prep Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.15
          }} className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-3xl p-8 border-2 border-emerald-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-2407" data-mp="f32xv56r3y32">
              <div className="absolute top-4 right-4 bg-emerald-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-2408" data-mp="2qrg58fk6eoou">
                NEW 🏡
              </div>
              <div className="text-3xl mb-4" data-id="element-2409" data-mp="1y2ipaj3ft3z9">🏡</div>
              <h3 className="font-heading text-2xl font-bold text-emerald-800 mb-4" data-id="element-2410" data-mp="1xzwg6f0wegex">
                Free Pre-Trip Home Prep Checklist
              </h3>
              <p className="text-emerald-600 font-medium mb-8 flex-grow" data-id="element-2411" data-mp="27yvqe21bak41">
                What to do before you leave so you come back to a peaceful,
                clean home. 10 sections covering everything from kitchen prep to
                security!
              </p>
              <Link to="/free-resources/travel/home-prep" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-emerald-500 text-white font-bold text-sm hover:bg-emerald-600 transition-colors shadow-lg shadow-emerald-500/20 w-full" data-id="element-2412" data-mp="1k9szs4op9gxe">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-2413" data-mp="1ly4zhwe1rqkr" />
              </Link>
            </motion.div>

            {/* FREE WORKOUT CONSULTATION Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-gradient-to-br from-sky-50 to-lavender-50 rounded-3xl p-8 border-2 border-sky-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-2414" data-mp="taitkhhck9uq">
              <div className="absolute top-4 right-4 bg-sky-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-2415" data-mp="29nz8u3z5qx09">
                FREE 💪
              </div>
              <div className="text-3xl mb-4" data-id="element-2416" data-mp="gmauu4pmo7c">💪</div>
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-4" data-id="element-2417" data-mp="dzty3vxiwcg">
                Free Workout Consultation
              </h3>
              <p className="text-plum-600 font-medium mb-3 flex-grow" data-id="element-2418" data-mp="3nkaco4apz1rg">
                Meet Jake — once the smallest in the room, now lifting over 500
                lbs and training for championship-level competition. His journey
                is proof of what consistency and discipline can do.
              </p>
              <p className="text-plum-500 text-sm font-medium mb-6" data-id="element-2419" data-mp="5enubg61spjc">
                Free consultations, zero pressure — just real advice from
                someone who's been exactly where you are.
              </p>
              <a href="https://calendly.com/trippinwithmandy/free-consultation-call" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-sky-500 text-white font-bold text-sm hover:bg-sky-600 transition-colors shadow-lg shadow-sky-500/20 w-full" data-id="element-2420" data-mp="y2tfu54xeik8">
                Book Free Consultation
                <ArrowRightIcon className="w-4 h-4" data-id="element-2421" data-mp="2wewks7hys6hf" />
              </a>
            </motion.div>
          </div>

          {/* PANIC ATTACK GROUNDING - Full width between rows */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-blush-50 to-lavender-50 rounded-3xl p-8 md:p-10 shadow-lg border border-blush-100 my-12" data-id="element-2422" data-mp="3t6qftkp1b567">
            <div className="text-center mb-6" data-id="element-2423" data-mp="bwsd4zqil6fy">
              <div className="text-4xl mb-3" data-id="element-2424" data-mp="bvqyklaai1th">🫧</div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-plum-700 mb-2" data-id="element-2425" data-mp="j7wzqdnla72x">
                Struggling with a Panic Attack?
              </h2>
              <p className="text-plum-500 font-semibold" data-id="element-2426" data-mp="o7jmbdpb4zoe">
                If you're having anxiety or a panic attack, try this grounding
                technique:
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto" data-id="element-2427" data-mp="x99cyhbd7ul4">
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-2428" data-mp="125zsn3j9co60">
                <span className="text-3xl block mb-3" data-id="element-2429" data-mp="174b39ghdn2pa">👀</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-2430" data-mp="1bw2m14uak44v">
                  See 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-2431" data-mp="1gunolax0mzwh">
                  Look around and name 5 things you can see right now.
                </p>
              </div>
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-2432" data-mp="1pvu6nofbciru">
                <span className="text-3xl block mb-3" data-id="element-2433" data-mp="3lyqj96mqpjo1">✋</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-2434" data-mp="3lx5kt5xb1gkw">
                  Feel 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-2435" data-mp="3vpuwo1wrowgr">
                  Touch 5 different textures — your shirt, the table, your hair.
                </p>
              </div>
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-2436" data-mp="9i3c3qnl0fae">
                <span className="text-3xl block mb-3" data-id="element-2437" data-mp="4ja8qr20e4ny">👂</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-2438" data-mp="4iqo32kz5268">
                  Hear 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-2439" data-mp="djoxk0e6m1w7">
                  Close your eyes and listen for 5 sounds around you.
                </p>
              </div>
            </div>
            <p className="text-cta-500 font-bold text-center mt-6 text-sm italic" data-id="element-2440" data-mp="2kbzfknmaydmw">
              This helps bring your mind back to the present moment. You're
              going to be okay. 💗
            </p>
          </motion.div>

          {/* GRID ROW 2 */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-2441" data-mp="zqss8oyd92ob">
            {/* Card 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-blush-50 rounded-3xl p-8 border border-blush-100 shadow-sm" data-id="element-2442" data-mp="m0gw8eynujrw">
              <div className="text-3xl mb-4" data-id="element-2443" data-mp="72ojfuki09he">🧘‍♀️</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-2444" data-mp="759m2lsmetg7">
                Things You Can Do Right Now
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-2445" data-mp="21hr0d3vhej8p">
                <li className="flex items-start gap-2" data-id="element-2446" data-mp="p84aeod1xrwl">
                  <span className="text-cta-500 mt-1" data-id="element-2447" data-mp="p7kwrjufppod">•</span> Take a deep
                  breath (seriously—slow it down)
                </li>
                <li className="flex items-start gap-2" data-id="element-2448" data-mp="fi1b66fc7hpt">
                  <span className="text-cta-500 mt-1" data-id="element-2449" data-mp="fgq3vwmonrty">•</span> Drink some water
                </li>
                <li className="flex items-start gap-2" data-id="element-2450" data-mp="aiomdg4wo0kl">
                  <span className="text-cta-500 mt-1" data-id="element-2451" data-mp="6i5w3qinv2ki">•</span> Step outside for
                  a few minutes
                </li>
                <li className="flex items-start gap-2" data-id="element-2452" data-mp="1hqf8oz67cxs">
                  <span className="text-cta-500 mt-1" data-id="element-2453" data-mp="3sokubqqpmhxv">•</span> Text someone you
                  trust
                </li>
                <li className="flex items-start gap-2" data-id="element-2454" data-mp="3nqt5x6p9xdyf">
                  <span className="text-cta-500 mt-1" data-id="element-2455" data-mp="3ns45euborzjq">•</span> Put on music that
                  grounds you
                </li>
              </ul>
            </motion.div>

            {/* Card 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-lavender-50 rounded-3xl p-8 border border-lavender-100 shadow-sm" data-id="element-2456" data-mp="1ufdn8km8gyvg">
              <div className="text-3xl mb-4" data-id="element-2457" data-mp="1bi43t3gwrle7">📓</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-2458" data-mp="1fhl8vvsfagiu">
                Quick Reset Questions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-2459" data-mp="1kfmrygpumfub">
                <li className="flex items-start gap-2" data-id="element-2460" data-mp="1pgkknn8hisa2">
                  <span className="text-cta-500 mt-1" data-id="element-2461" data-mp="1pe7w2r881jo1">•</span> What am I feeling
                  right now?
                </li>
                <li className="flex items-start gap-2" data-id="element-2462" data-mp="30v7mtiex7qfy">
                  <span className="text-cta-500 mt-1" data-id="element-2463" data-mp="30tmr3pgve1gi">•</span> What do I
                  actually need today?
                </li>
                <li className="flex items-start gap-2" data-id="element-2464" data-mp="1a7kdgav3336t">
                  <span className="text-cta-500 mt-1" data-id="element-2465" data-mp="1a72dp497q6u5">•</span> What's one small
                  thing I can do?
                </li>
              </ul>
            </motion.div>

            {/* Card 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-sky-50 rounded-3xl p-8 border border-sky-100 shadow-sm" data-id="element-2466" data-mp="11dfipgctx7m0">
              <div className="text-3xl mb-4" data-id="element-2467" data-mp="27usyy5v34c8t">🎧</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-2468" data-mp="27t9fk6e4tl2t">
                My Go-To Distractions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-2469" data-mp="2mxubwpsirwwu">
                <li className="flex items-start gap-2" data-id="element-2470" data-mp="2mvzpt85ihyr6">
                  <span className="text-cta-500 mt-1" data-id="element-2471" data-mp="2i0c3r1mbtlpw">•</span> A comfort show
                  (Gilmore Girls, anyone?)
                </li>
                <li className="flex items-start gap-2" data-id="element-2472" data-mp="2vss4twvo39o6">
                  <span className="text-cta-500 mt-1" data-id="element-2473" data-mp="2qywbx8u9gczv">•</span> A podcast that
                  feels like talking to a friend
                </li>
                <li className="flex items-start gap-2" data-id="element-2474" data-mp="35qoj2xjwikqi">
                  <span className="text-cta-500 mt-1" data-id="element-2475" data-mp="30oz3d4lqhiw3">•</span> Scrolling through
                  travel TikToks
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}